import { render, staticRenderFns } from "./OrdiniInArrivo.vue?vue&type=template&id=5f751532&"
import script from "./OrdiniInArrivo.vue?vue&type=script&lang=ts&"
export * from "./OrdiniInArrivo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports